export var max = Math.max;
export var min = Math.min;
export var round = Math.round;


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/utils/math.js
// module id = ./node_modules/@popperjs/core/lib/utils/math.js
// module chunks = 1